import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TranslationService } from '../../services/translationService';

@Component({
  selector: 'pixl-lang',
  standalone: true,
  imports: [],
  template: '{{ translatedText() }}',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslateComponent {
  readonly key = input.required<string>();
  readonly keyPrefix = input<string>();
  readonly keySuffix = input<string>();

  private readonly translationService = inject(TranslationService);

  readonly translatedText = computed(() => {
    const key = this.key();
    const prefix = this.keyPrefix();
    const suffix = this.keySuffix();

    const keyToTranslate = prefix ? `${prefix}.${key}` : suffix ? `${key}.${suffix}` : key;
    return this.translationService.translate(keyToTranslate) || `?${keyToTranslate}?`;
  });
}
